import { dataguard } from '@/renderer/utils/vike/dataguard';

export async function data(pageContext: Vike.PageContext) {
  // pre-load the session info for this page
  return await dataguard(pageContext, { ignoreLoggedOut: true, fetchOn: 'both' });
}
